import { messages } from '@/lib/messages'
import type { DocumentFilter } from '@/services/cube/document'

/**
 * `filters.<üye>` metni: canlı kaynakla aynı kural, değerler kopyaya yazılmış seçimden gelir.
 * Donmuş kaynak (okuma) ile kopya üretimi (açma) aynı metni üretsin diye tek yerde durur.
 */
export function selectedText(
  config: { filters: DocumentFilter[]; filterValues: Record<string, unknown> },
  member: string,
): string {
  const filter = config.filters.find(
    (item) => item.member === member && (item.type === 'multiSelect' || item.type === 'boolean'),
  )
  if (!filter) return messages.common.empty
  const value = config.filterValues[member]
  if (filter.type === 'boolean') {
    if (typeof value !== 'boolean') return messages.common.all
    return value ? messages.common.yes : messages.common.no
  }
  const values = Array.isArray(value) ? value : typeof value === 'string' && value ? [value] : []
  return values.length > 0 ? values.join(', ') : messages.common.all
}
